import type { User } from './user';
import type { Fish } from './fish';
import type { Space, Venue } from './venue';
import { TicketedEvent } from './ticketedEvents';

export enum AssetType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

export interface AssetTag {
  id: string;
  name: string;
  assets?: AssetTagAsset[];
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}

export interface AssetTagAsset {
  assetId: string;
  tagId: string;
  tag?: AssetTag;
}

export type AssetTagValue = {
  id?: string;
  name: string;
};

export interface UpdateAssetPayload {
  tags?: AssetTagValue[];
}

export interface Asset {
  id: string;
  cloudinaryId: string;
  cloudinaryAssetId: string;
  type: AssetType;

  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;

  createdByUserId: string | null;
  deletedByUserId: string | null;
  createdByFishId: string | null;
  deletedByFishId: string | null;

  createdByUser?: User | null;
  deletedByUser?: User | null;
  createdByFish?: Fish | null;
  deletedByFish?: Fish | null;

  space: Space[];
  venue: Venue[];
  fish: Fish[];

  ticketedEventsFeatured?: TicketedEvent[]; // TicketedEventFeaturedImage relation
  ticketedEvents?: TicketedEvent[]; // TicketedEventImages relation

  tags?: AssetTagAsset[];

  spaceFeaturedImage?: Space[]; // SpaceFeaturedImage
  images?: Space[]; // SpaceImages
  floorPlanAssets?: Space[]; // SpaceFloorPlanImages
}
